<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 16"
    fill="none"
    v-bind="$attrs"
    :width="width"
    :height="width"
  >
    <path
      d="M11.5 3.38152H9.5V1.95103C9.5 1.31983 9.05156 0.806641 8.5 0.806641H3.5C2.94844 0.806641 2.5 1.31983 2.5 1.95103V3.38152H0.5C0.223437 3.38152 0 3.63722 0 3.95371V4.52591C0 4.60459 0.05625 4.66896 0.125 4.66896H1.06875L1.45469 14.0208C1.47969 14.6305 1.92031 15.1115 2.45312 15.1115H9.54688C10.0813 15.1115 10.5203 14.6323 10.5453 14.0208L10.9312 4.66896H11.875C11.9438 4.66896 12 4.60459 12 4.52591V3.95371C12 3.63722 11.7766 3.38152 11.5 3.38152ZM3.625 2.09408H8.375V3.38152H3.625V2.09408ZM9.42656 13.8241H2.57344L2.19531 4.66896H9.80469L9.42656 13.8241Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 12,
  },
  height: {
    type: [String, Number],
    default: 16,
  },
  fill: {
    type: String,
    default: '#1b3c77',
  }
});
</script>